import { render } from "./CommonInfo.html?vue&type=template&id=b002ad88&ts=true"
import script from "./CommonInfo.ts?vue&type=script&lang=ts"
export * from "./CommonInfo.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__